import React from "react";
import PropTypes from "prop-types";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

const BillingDocumentSendingTableRow = ({ row }) => (
  <TableRow>
    <TableCell />
    <TableCell align="left">{row.id}</TableCell>
  </TableRow>
);
BillingDocumentSendingTableRow.propTypes = {
  row: PropTypes.object.isRequired,
};

export default BillingDocumentSendingTableRow;
